import "./style/style2.css"
import Footer from './Footer';

import YBlogo from './images/Yacin-Benziane-Logo.png'
import copyIcon from './images/copy.svg'
import arrowIcon from './images/arrow.svg'
import ScrollToTop from './ScrollToTop';

import {Link } from 'react-router-dom';

import { useState } from 'react';

import { useLenis } from '@studio-freight/react-lenis'

import { motion } from 'framer-motion';

import me from './images/me.jpg'



export default function BCard () {

    const [TextOpacity, setTextOpacity] = useState('.0');
    const [TextPos, setTextPos] = useState('77px');

    const lenis = useLenis(({ scroll }) => {
        // called every scroll
      })

      function timeout(delay: number) {
        return new Promise( res => setTimeout(res, delay) );
    }

    const handleCopyEmail = async () => {


        // Copy the text inside the text field

       var tempInput = document.createElement('input');
       tempInput.value = "benzianeoyacine@gmail.com";
       document.body.appendChild(tempInput);
       tempInput.select();
       document.execCommand('copy');
       document.body.removeChild(tempInput);

                   // Alert the copied text

         setTextOpacity('0');
         setTextPos('77px');
         await timeout(100); //for 1 sec delay

         setTextOpacity('.3');
         setTextPos('0px');



   }



   const handleCopyPhone = async () => {
        // Copy the text inside the text field
         var tempInput = document.createElement('input');
         tempInput.value = "+4917659532446";
         document.body.appendChild(tempInput);
         tempInput.select();
         document.execCommand('copy');
         document.body.removeChild(tempInput);

         setTextOpacity('0');
         setTextPos('77px');

         await timeout(100); //for 1 sec delay

         setTextOpacity('.3');
         setTextPos('0px');

   }



    const handleCopyLinkedin = async () => {
        // Copy the text inside the text field
         var tempInput = document.createElement('input');
         tempInput.value = "https://www.linkedin.com/in/yacineb/";
         document.body.appendChild(tempInput);
         tempInput.select();
         document.execCommand('copy');
         document.body.removeChild(tempInput);

         setTextOpacity('0');
         setTextPos('77px');

         await timeout(100); //for 1 sec delay

         setTextOpacity('.3');
         setTextPos('0px');

   }


    return(

    <ScrollToTop>

        <motion.div  class='rootBody' initial= {{opacity:0}} animate= {{opacity:1}} exit={{opacity: 1}} transition = {{ duration: 1, ease: [0.22, 1, 0.36, 1] }} >
                                    
            <div class="homePage" id="home">
                 {/*Copied ! text */}
                {/*Menu */}

                <div class="menu">
                    <div class="siteName"><Link to="/" style={{ 'text-decoration': 'none'}}><img src={YBlogo}/></Link></div>
                    <div class="menuLinks">

                    <a href='/#projects' class="link">Work</a>
                    <Link to="/about" style={{  'text-decoration': 'none'}}><div class="link">About</div></Link>
                    <Link to="/contact" style={{  'text-decoration': 'none'}}><div class="link">Contact</div></Link>

                        {/* EN | FR */}

                    </div>
                </div>

            
                    {/* CARD */}
                <div class='contactSection' style={{ width: '100%', 'min-height': '111px', 'height': '89vh', 'padding':'81px 0px', gap: '37px' }}>


                            <div id="flexColCenter">
                                <img src={me} style={{ filter: 'brightness(113%)', borderRadius: '113px', width: '173px', height: '173px' , objectFit: 'cover', border: 'solid 3px #fff', boxShadow: '0px 0px 10px rgba(0,0,0,0.2)'}} />
                                <h3 className="heroText" id='letsCon' style={{ width: 'auto', padding: '0px 0 0 0', margin: '0'}}>Yacine Benziane</h3>
                                <div>Fullstack Developer</div>
                            </div>


                            <div id="letsCon" style={{'font-size': '24px','font-weight': '600', 'opacity': TextOpacity, transition: 'opacity, transform 200ms ease-out', margin: '-29px', transform: 'translateY('+TextPos+')'}}> Copied !</div>
                               <div >


                                <div class='pill'  >
                                    <div class="pillContent"  style={{color: '#333'}}>linkedin/in/yacineb</div>

                                    <div class="pillBtn" style={{display: 'flex'}}>
                                        <div class='iconCircle'  onClick={handleCopyLinkedin}><img src={copyIcon}/></div>
                                        <div class='iconCircle' id="emailAwrow"><a href="https://www.linkedin.com/in/yacineb/" target="_blank"><img src={arrowIcon} style={{margin: '-5px'}}/></a></div>
                                    </div>
                                </div>


                                <div class='pill'>
                                    <div class="pillContent"  style={{color: '#333'}}>+49&nbsp;176&nbsp;595&nbsp;324&nbsp;46</div>
                                    <div class="pillBtn" style ={{display: 'flex'}}>
                                        <div class='iconCircle' onClick={handleCopyPhone}><img src={copyIcon}/></div>
                                        <div class='iconCircle'id="emailAwrow"><a href="tel:+4917659532446"><img src={arrowIcon} style={{margin: '-5px'}}/></a></div>
                                    </div>
                                </div>

                                       <div class='pill' style={{fontSize: '15px'}}>
                                    <div class="pillContent"  style={{color: '#333'}}>benzianeoyacine@gmail.com</div>

                                    <div class="pillBtn" style={{display: 'flex'}}>
                                        <div class='iconCircle'  onClick={handleCopyEmail}><img src={copyIcon}/></div>
                                        <div class='iconCircle' id="emailAwrow"><a href="mailto:benzianeoyacine@gmail.com"><img src={arrowIcon} style={{margin: '-5px'}}/></a></div>
                                    </div>
                                </div>

                                </div>
                    </div>
                    


                    <Footer/>

                   
                        


                    </div>
                    







            </motion.div>
        </ScrollToTop>


    )
}